import request from '@/utils/request'
// 上传文件
export function fileUpload(params) {
	return request({
		url: '/file/upload',
		method: 'post',
		data: params
	})
}

// 初始化通用文件预签名上传
export function initPresignedFileUpload(params) {
	return request({
		url: '/file/upload/init',
		method: 'post',
		data: params
	})
}

// 确认通用文件预签名上传完成
export function completePresignedFileUpload(params) {
	return request({
		url: '/file/upload/complete',
		method: 'post',
		data: params
	})
}

// 筛选指定文件列表
export function assignFileList(params) {
	return request({
		url: '/information/material/user',
		method: 'post',
		data: params
	})
}

// 批量删除文件
export function batchDeleteResource(params) {
	return request({
		url: '/file/batch-delete',
		method: 'post',
		data: params
	})
}

// 获取文件详情
export function fileDetail(params) {
	return request({
		url: '/file/get',
		method: 'get',
		params: params
	})
}

// 智能助手
// export function chart(params) {
// 	return request({
// 		url: '/ai/chat/kb_chat',
// 		method: 'post',
// 		data: params
// 	})
// }

// 社区统计
export function communityData() {
	return request({
		url: 'management/about/overview',
		method: 'get',
	})
}
